function IgGridHelpers() { }

//check if saved filter settings exist 
IgGridHelpers.SessionStorageHasGroupByColumnsSettings = function (controlName) {
    var savedSettingsJson = sessionStorage.getItem(window.location.pathname + controlName);
    var savedSettings = JSON.parse(savedSettingsJson);
    if (savedSettings) {
        if (savedSettings.groupByColumnsSettings) {
            if (savedSettings.groupByColumnsSettings.length > 0) {
                return true;
            }
        }
    }
    return false;
}

//save filters, sorting, paging and grouping
IgGridHelpers.SaveIgGridFilteringSettings = function (selector, ui, controlName) {

    var $element = $(selector);
    var oldSettings = sessionStorage.getItem(window.location.pathname + controlName);
    oldSettings = JSON.parse(oldSettings);
    var oldPageIndex = 0;
    if (oldSettings) {
        oldPageIndex = oldSettings.pageIndex
    }

    var igGridFilterSettings = {
        columnSettings: $element.igGridSorting('option', 'columnSettings'),
        filteringSettings: $element.data('igGrid').dataSource.settings.filtering.expressions,
        pageIndex: ui.pageIndex != null ? ui.pageIndex : oldPageIndex,
        groupByColumnsSettings: $element.igGridGroupBy("groupByColumns")
    };
    sessionStorage.setItem(window.location.pathname + controlName, JSON.stringify(igGridFilterSettings));
}

// load filters, sorting, groupby to initial iggrid features
IgGridHelpers.LoadIgGridFilteringSettings = function (selector, gridReference, controlName) {
    var $element = $(selector);
    var savedSettingsJson = sessionStorage.getItem(window.location.pathname + controlName);
    var savedSettings = JSON.parse(savedSettingsJson);

    if (!savedSettings) {
        return;
    }

    //set saved grouping, filtering, paging and sorting
    var features = gridReference.options.features;
    for (var i = 0; i < features.length; i++) {
        if (features[i].name == "GroupBy" && savedSettings.groupByColumnsSettings) {
            features[i].columnSettings = []
            for (var j = 0; j < savedSettings.groupByColumnsSettings.length; j++) {
                if (savedSettings.groupByColumnsSettings[j].key) {
                    features[i].columnSettings.push({ columnKey: savedSettings.groupByColumnsSettings[j].key, isGroupBy: true, dir: savedSettings.groupByColumnsSettings[j].dir, persist: true });
                }
            }
        }

        else if (features[i].name == "Paging") {
            features[i].currentPageIndex = savedSettings.pageIndex != null ? savedSettings.pageIndex : 0;
        }

        else if (features[i].name == "Filtering" && savedSettings.filteringSettings) {
            features[i].columnSettings = []
            for (var j = 0; j < savedSettings.filteringSettings.length; j++) {
                features[i].columnSettings.push({
                    columnKey: savedSettings.filteringSettings[j].fieldName, defaultExpressions: [
                        { expr: savedSettings.filteringSettings[j].expr, cond: savedSettings.filteringSettings[j].cond }]
                });
            }
        }

        else if (features[i].name == "Sorting" && savedSettings.columnSettings) {
            for (var j = 0; j < savedSettings.columnSettings.length; j++) {
                if (savedSettings.columnSettings[j].currentSortDirection) {
                    features[i].columnSettings = [];
                    features[i].columnSettings.push(savedSettings.columnSettings[j]);
                }
            }
        }
    }

    //set saved grid features
    gridReference._destroyFeatures();
    gridReference.options.features = features;
}
